var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "17.5",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 11.3h-2.01v1.05h-.69v-1.17c0-.38.3-.68.69-.68h2c.38 0 .7.3.7.68v1.17h-.7v-1.06zm8.4 0h-2v1.05h-.7v-1.17c0-.38.31-.68.7-.68h2c.38 0 .69.3.69.68v1.17h-.7v-1.06zm-1.72 5.82h.97v1.43h1.44v.95h-1.44v1.42h-.97V19.5h-1.44v-.95h1.44v-1.43zm-9.49 2.38h3.87v-.94h-3.87v.94zm-1.5 5.7c-.65 0-1.19-.6-1.19-1.35V14.2c0-.75.54-1.35 1.2-1.35h15.1c.66 0 1.2.6 1.2 1.35v9.65c0 .74-.54 1.35-1.2 1.35H10.3z",
    fill: "#FFF"
  })));
});